import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        mainContainer: {
            display: 'flex !important',
            alignItems: 'center !important',
            height: '100%',
        },
        formContainer: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
        formOuter: {
            [theme.breakpoints.down('md')]: {
                width: '100% !important',
                padding: '25px !important',
            },
            width: '47% !important',
            padding: '30px 50px !important',
            border: '1px solid #D8D8D8',
            boxShadow: '0 2px 3px #00000029',
        },
        formHeading: {
            width: '100%', 
            paddingBottom: '10px',
            borderBottom: '1px solid #dee2e6', 
        },
    }),
);

export default useStyles;